import SC from "../constants/AmuletStackerConstants"

export const selectChain = (chain) => (dispatch) => {
  dispatch({
    type: SC.SET_SELECTED_CHAIN,
    payload: chain,
  })
}

export const resetAmulet = () => (dispatch) => {
  dispatch({
    type: SC.RESET_CHAIN,
  })
}
